import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationStatus = ({ status, message }) => {
  const statusConfig = {
    idle: {
      icon: 'Mail',
      iconColor: 'var(--color-primary)',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary'
    },
    verifying: {
      icon: 'Loader2',
      iconColor: 'var(--color-primary)',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary',
      animate: true
    },
    success: {
      icon: 'CheckCircle2',
      iconColor: 'var(--color-success)',
      bgColor: 'bg-success/10',
      textColor: 'text-success'
    },
    error: {
      icon: 'XCircle',
      iconColor: 'var(--color-error)',
      bgColor: 'bg-error/10',
      textColor: 'text-error'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.idle;

  return (
    <div className={`${config?.bgColor} rounded-xl p-4 sm:p-6 mb-4 sm:mb-6 transition-all duration-300`}>
      <div className="flex items-start gap-3 sm:gap-4">
        <div className={`flex-shrink-0 ${config?.animate ? 'animate-spin' : ''}`}>
          <Icon name={config?.icon} size={20} className="sm:hidden" color={config?.iconColor} />
          <Icon name={config?.icon} size={24} className="hidden sm:block" color={config?.iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`${config?.textColor} font-medium text-xs sm:text-sm md:text-base break-words`}>
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationStatus;